import { registryApi } from '../clients/AxiosClients'
import i18n from '../../VueI18n'

/**
 * Retorna todos os executores cadastrados no banco de dados
 */
const getAllExecutores = async () => {
	return registryApi.get('v1/Executor')
}
/*
* Retorna todas as fazendas cadastrados no banco de dados

*/
const getAllFazendas = async () => {
	return registryApi.get('v2/Fazenda')
}

/**
 * Cadastrar novo executor no banco de dados
 * @param {Object} body Executor que será cadastrado
 */
const createExecutor = async (body) => {
	return registryApi.post('v1/Executor', body)
}

/**
 * Atualiza executor no banco de dados
 * @param {Object} body Executor que será atualizada
 */
const updateExecutor = async (body) => {
	return registryApi.put('v1/Executor', body)
}

/**
 * Lista dos ids de executores que devem ser excluidos do banco de dados
 * @param {Array} body Lista dos ids de executores
 */
const deleteExecutorByIdList = async (data) => {
	return registryApi.delete('v1/Executor/DeleteByIdList', { data })
}

/**
 * Retorna todos os executores estruturadas para o componente de DropdownFk
 */
const getDropdownExecutores = async () => {
	const {
		data: { result },
	} = await registryApi.get('v1/Executor/GetDropdown')
	return result.map((executor) => {
		return {
			id: executor.id,
			[i18n.t('code')]: `EX-${executor.extr_cd_codigo}`,
			[i18n.t('name')]: executor.extr_nm_nome,
			[i18n.t('phone')]: executor.extr_tx_telefone,
			[i18n.t('blocked')]: executor.extr_is_bloqueado,
		}
	})
}

const recuperarExecutoresComMediaDeParcelasPorDia = async () => {
	return await registryApi.get('v1/executor/recuperar-executor-com-media-de-parcelas-por-dia')
}

export {
	getAllExecutores,
	getAllFazendas,
	createExecutor,
	updateExecutor,
	deleteExecutorByIdList,
	getDropdownExecutores,
	recuperarExecutoresComMediaDeParcelasPorDia,
}
